import type { BroadcastReadRow, BroadcastRow, MemberTerminalRow } from '@routeback/core';
import { useLiveQuery } from 'dexie-react-hooks';
import { useApp } from '../../lib/app';
import { inbox, readId, type InboxItem } from './messages';

/** My inbox, live from the phone (works offline). */
export function useInbox(): InboxItem[] | undefined {
  const app = useApp();
  return useLiveQuery(async () => {
    const c = app.company.id;
    const [b, r, mt] = await Promise.all([
      app.db.table<BroadcastRow, string>('broadcasts').where('company_id').equals(c).toArray(),
      app.db.table<BroadcastReadRow, string>('broadcast_reads').where('company_id').equals(c).toArray(),
      app.db.table<MemberTerminalRow, string>('member_terminals').where('company_id').equals(c).toArray(),
    ]);
    const mine = mt.filter((m) => !m.deleted_at && m.user_id === app.userId).map((m) => m.terminal_id);
    return inbox(b, r, app.userId, mine);
  }, [app.db, app.company.id, app.userId]);
}

/** Mark a message opened (once per person; the same row from any phone). */
export async function markRead(app: ReturnType<typeof useApp>, broadcastId: string): Promise<void> {
  const id = await readId(broadcastId, app.userId);
  if (await app.repos.broadcastReads.get(id)) return;
  await app.repos.broadcastReads.save({ ...app.repos.broadcastReads.blank({ user_id: app.userId, broadcast_id: broadcastId, read_at: new Date().toISOString() }), id });
}
